@if (isMaintenanceMode()) {
  <div class="maintenance-mode-overlay">
    <div class="maintenance-mode-content">
      <h1>Mantenimiento</h1>
      <p>La plataforma está en mantenimiento. Por favor, inténtalo de nuevo más tarde.</p>
    </div>
  </div>
}
@if (isAppReady()) {
  @if (isDashboardRoute()) {
    <div class="dashboard-container">
      <app-dashboard-menu [overlayActive]="isMaintenanceMode() || !!alert() || !!loading() || !!popover() || sidePanels().length > 0" />
      <main class="dashboard-content-container">
        <router-outlet />
      </main>
    </div>
  } @else {
    <div class="public-container">
      <div class="public-header">
        <div class="public-header-logo">Portal Desarrolladores<span class="logo-spacer"></span>Mundo Hogar</div>
        <div class="public-header-profile">Acceso administrador</div>
      </div>
      <main class="public-content-container">
        <router-outlet />
      </main>
    </div>
  }
}
<app-toast />
@if (popover(); as activePopover) {
  <app-popover-options [popover]="activePopover" />
}
@for (sidePanel of sidePanels(); track sidePanel.id) {
  <app-side-panel-wrapper [sidePanel]="sidePanel" />
}
@if (alert(); as activeAlert) {
  <app-alert [alert]="activeAlert" />
}
@if (loading(); as label) {
  <app-loading-alert [label]="label" />
}
